import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { PanelEffects } from './panel.effects';
import { reducer, initialState } from './panel.reducer';
import { createLocalStorageSyncReducer } from '../local-storage-sync';
import { PanelState } from './panel.state';
import { getEnvironment } from '../../features/shared/utils/get-environment';

const syncMetaReducer = createLocalStorageSyncReducer<PanelState>({
  keys: ['activePanelViews', 'alignState', 'sectionSizes', 'smallViewPanel'],
  rehydrate: true,
  storage: localStorage,
  storageKeySerializer: (key) => `semeris-${getEnvironment()}-${key}`,
});

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('panel', reducer, { initialState, metaReducers: [syncMetaReducer] }),
    EffectsModule.forFeature([PanelEffects]),
  ],
  providers: [PanelEffects],
})
export class PanelStoreModule {}
